import EmblaCarousel from 'embla-carousel';
import { setupPrevNextBtns, disablePrevNextBtns } from '../helpers/carousel-buttons';

(() => {
  const slider = document.querySelectorAll('.m17');

  slider.forEach(carousel => {
    const viewport = carousel.querySelector('.m17__wrapper');
    const slides = viewport.querySelectorAll('.m17__slide');

    const isLessThanThree = slides.length <= 3 && window.outerWidth >= 810;

    const options = {
      slidesToScroll: 1,
      align: isLessThanThree ? 'center' : 'start',
      startIndex: isLessThanThree ? 1 : 0,
      draggable: true,
      containScroll: isLessThanThree ? '' : 'trimSnaps'
    };

    const embla = EmblaCarousel(viewport, options);

    const prevBtn = carousel.querySelector('.m17__button--prev');
    const nextBtn = carousel.querySelector('.m17__button--next');
    const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, embla);

    setupPrevNextBtns(prevBtn, nextBtn, embla);

    const buttonUpdates = () => {
      if (! isLessThanThree) {
        prevBtn.classList.remove('hide-button');
        nextBtn.classList.remove('hide-button');
        disablePrevAndNextBtns();
      } else {
        prevBtn.classList.add('hide-button');
        nextBtn.classList.add('hide-button');
      }
    };

    embla.on('init', () => buttonUpdates());
    embla.on('select', () => buttonUpdates());
    embla.on('resize', () => buttonUpdates());

    if (isLessThanThree) {
      prevBtn.setAttribute('disabled', 'disabled');
      nextBtn.setAttribute('disabled', 'disabled');
    }
  });
})();
